module.exports = __webpack_public_path__ + "img/vespa_110.a95cef94.png";